import styled from "styled-components";

const DeliveryStatusLabelStyled = styled.div`
    color: ${props => props.theme.black};
    align-self: flex-start;

	span {
		display: inline;
		background-color: ${props => props.theme.lightBlue2};
		padding: 0.6rem 0.8rem;
		font-size: 1.2rem;
		font-weight: 400;
    	border-radius: 0.5rem;
		padding-left: 2.4rem;
		position: relative;

		&:before {
			content: '';
			position: absolute;
			width: 1rem;
			height: 1rem;
			border-radius: 0.5rem;
			left: 0.8rem;
			top: 0.8rem;
			background-color: ${props => props.theme.blue};
   		 }
	}

    &.orange {
		span {
        	background-color: ${props => props.theme.lightOrange};

			&:before {
            	background-color: ${props => props.theme.orange};
        	}
		}
    }

    &.green {
		span {
        	background-color: ${props => props.theme.lightGreen2};

			&:before {
           	 	background-color: ${props => props.theme.green};
        	}
		}
    }

    &.red {
		span {
        	background-color: ${props => props.theme.lightRed};

			&:before {
            	background-color: ${props => props.theme.red};
        	}
		}
    }

    &.gold {
		span {
        	background-color: ${props => props.theme.lightGold};

			&:before {
            	background-color: ${props => props.theme.gold};
        	}
		}
    }
`;

export default DeliveryStatusLabelStyled;
